export * from './window-type-3.component';